import { render, staticRenderFns } from "./widget-stat-chart.vue?vue&type=template&id=0b9e96e5&"
import script from "./widget-stat-chart.vue?vue&type=script&lang=js&"
export * from "./widget-stat-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports